import {DataStatus} from 'platform/components';
import {match} from 'ts-pattern';

import {ReactNode, Suspense} from 'react';

import {RestrictedArea} from '@dms/shared';

const REPORT_MIN_HEIGHT = 100;

interface ReportAccessGuardProps {
  hasAccess: boolean;
  isLoading: boolean;
  isError: boolean;
  children: ReactNode;
  'data-testid'?: string;
}

/**
 * Guards importer report pages whose routes are registered unconditionally
 * (deep links bypass the menu filter entirely), so each page must resolve its own
 * entitlement before rendering its lazy content.
 */
export function ReportAccessGuard(props: ReportAccessGuardProps) {
  return match({hasAccess: props.hasAccess, isLoading: props.isLoading, isError: props.isError})
    .with({isLoading: true}, () => (
      <DataStatus minHeight={REPORT_MIN_HEIGHT} isLoading data-testid={props['data-testid']} />
    ))
    .with({isError: true}, () => (
      <DataStatus minHeight={REPORT_MIN_HEIGHT} isError data-testid={props['data-testid']} />
    ))
    .with({hasAccess: false}, () => <RestrictedArea />)
    .otherwise(() => (
      <Suspense
        fallback={
          <DataStatus minHeight={REPORT_MIN_HEIGHT} isLoading data-testid={props['data-testid']} />
        }
      >
        {props.children}
      </Suspense>
    ));
}
